import {Box, Divider, TextField, Typography} from "@mui/material";

interface ISoundbank {
    config: any
    soundbank: string
}
function Soundbank({config, soundbank}: ISoundbank) {
    return (
        <Box display="flex" flexDirection="column" m={1}>
            <Typography>{soundbank}</Typography>
            <Divider/>
            {config.resource_registry.base.soundbanks[soundbank].map((file: string) =>
                <Typography key={file}>{file}</Typography>
            )}
        </Box>
    );
}
interface ISoundConfig {
    config: any
    project: string
}
export function SoundConfig({config, project}: ISoundConfig) {
    if (! config?.resource_registry?.base?.soundbanks) {
        return (
            <Box display="flex">
                <Typography color="error">
                    There are no sound settings for the project so the build system will not be able to put the data
                    into the correct place. To set up the project update the settings in the open project dialog within
                    Cookbook.
                </Typography>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column">
            <Typography>
                The soundbanks are built with Wwise, zipped together into a file named SoundBanks.zip and uploaded to
                Frame.io. From there, they are downloaded and unzipped, the file SoundbanksInfo.xml under each
                architecture folder is parsed and the output structure is created and then uploaded to AWS
            </Typography>
            <TextField label="Soundbank path on AWS" size="small" sx={{flexGrow: 1, margin: 1}}
                       value={config.resource_registry.base.soundbank_level.vorbis}/>
            <Box m={1} sx={{border: 1, borderRadius: 1, borderColor: "lightGrey"}}>
                {Object.keys(config.resource_registry.base.soundbanks).map(soundbank =>
                    <Soundbank config={config} soundbank={soundbank}/>
                )}
            </Box>
        </Box>
    );
}